export const LAST_ACTIVITY_STORAGE_KEY = 'ofertator:lastActivityAt'

export function isIdleBeyondThreshold(
  lastActivityAt: number,
  now: number,
  inactivityMinutes: number,
): boolean {
  if (inactivityMinutes <= 0) return false
  return now - lastActivityAt >= inactivityMinutes * 60_000
}

export function readStoredLastActivityAt(): number | null {
  if (typeof window === 'undefined') return null
  const raw = sessionStorage.getItem(LAST_ACTIVITY_STORAGE_KEY)
  if (!raw) return null
  const parsed = Number(raw)
  return Number.isFinite(parsed) ? parsed : null
}

export function writeStoredLastActivityAt(timestamp: number): void {
  if (typeof window === 'undefined') return
  sessionStorage.setItem(LAST_ACTIVITY_STORAGE_KEY, String(timestamp))
}
